/**
 * A tag's last discussion in the reader's language: the first of their
 * preferences that is set, if the forum has it, and if the reader can see the
 * discussion, as its title is empty otherwise.
 */
export function localisedLastDiscussion(discussions, languages, preferredCodes) {
  const code = preferredCodes.find(Boolean);
  const languageId = languages.find(language => language.code() === code)?.id();
  const discussion = languageId ? discussions?.[languageId] : undefined;
  return discussion?.title ? discussion : undefined;
}
flarum.reg.add('fof-discussion-language', 'forum/utils/localisedLastDiscussion', { localisedLastDiscussion: localisedLastDiscussion, });